import React, { useState } from "react";
import { FaPlus, FaTimes, FaCheck, FaTrash } from "react-icons/fa";

const RoleSelector = ({
  roles,
  selectedRole,
  onChange /*, onAddRole, onDeleteRole*/,
}) => {
  const [isAdding, setIsAdding] = useState(false);
  const [newRole, setNewRole] = useState("");

  const handleAdd = () => {
    if (!newRole.trim()) return;
    // onAddRole(newRole.trim());
    onChange(newRole.trim());
    setNewRole("");
    setIsAdding(false);
  };

  const handleDelete = () => {
    if (!selectedRole) return;
    const confirm = window.confirm(`Hapus role "${selectedRole}"?`);
    if (confirm) {
      // onDeleteRole(selectedRole);
    }
  };

  return (
    <div className="mb-6">
      <label className="block mb-2 font-semibold text-green-700">
        Pilih Role:
      </label>

      {!isAdding ? (
        <div className="flex items-center gap-2">
          <select
            value={selectedRole}
            onChange={(e) => onChange(e.target.value)}
            className="px-4 py-2 text-green-800 border border-green-300 rounded-md focus:ring-2 focus:ring-green-500"
          >
            <option value="">-- Pilih Role --</option>
            {roles.map((role, i) => (
              <option key={i} value={role}>
                {role}
              </option>
            ))}
          </select>

          {/* Tombol tambah role */}
          {/*
          <button
            type="button"
            onClick={() => setIsAdding(true)}
            title="Tambah Role"
            className="p-2 text-white bg-green-600 rounded hover:bg-green-700"
          >
            <FaPlus size={14} />
          </button>
          */}

          {/* Tombol hapus role */}
          {/*
          {selectedRole && (
            <button
              type="button"
              onClick={handleDelete}
              title="Hapus Role"
              className="p-2 text-white bg-red-600 rounded hover:bg-red-700"
            >
              <FaTrash size={14} />
            </button>
          )}
          */}
        </div>
      ) : (
        <div className="flex items-center gap-2">
          {/* Form tambah role */}
          {/*
          <input
            type="text"
            value={newRole}
            onChange={(e) => setNewRole(e.target.value)}
            className="px-3 py-2 border border-green-300 rounded focus:ring-2 focus:ring-green-400"
            placeholder="Nama Role Baru"
            autoFocus
          />
          <button
            onClick={handleAdd}
            className="p-2 text-white bg-green-600 rounded hover:bg-green-700"
            title="Simpan"
          >
            <FaCheck size={14} />
          </button>
          <button
            onClick={() => {
              setIsAdding(false);
              setNewRole("");
            }}
            className="p-2 text-white bg-gray-400 rounded hover:bg-gray-500"
            title="Batal"
          >
            <FaTimes size={14} />
          </button>
          */}
        </div>
      )}
    </div>
  );
};

export default RoleSelector;
